
<div>
  <Heading
    :class="[jel_getClassObject(content, { [content.type]: true }), isArchiveEmpty]"
    :contentType="content.type"
    v-html="jel_replaceTokens(getIsArchiveMode ? content.titrePromotions : content.titre)"
  ></Heading>
</div>
